// extracted by mini-css-extract-plugin
module.exports =  {"agentBadge":"agentBadge--Iel6--qZzg+ryWfSm3KDdA==","agentIcon":"agentIcon--ppXWAZZIpBU0beJje+Y69g=="};